import api from '../api'
import auth from '../token'

const station = auth.getStationNumber();

export default {

  getConfigurations(page = 0, word = '', idStation = null, size = 5) {
    const role = localStorage.getItem('role');

    if (role === 'ADMIN' || role === 'SUPPORT') {
      if (!idStation || idStation === null) {
        return api.request('GET', '/configuration/list?page=' + page + '&word=' + word + '&size=' + size + '&order=asc');
      } else {
        return api.request('GET', '/configuration/list/' + idStation.station + '?page=' + page + '&word=' + word + '&size=' + size + '&order=asc');
      }
    } else {
      return api.request('GET', '/configuration/list/' + station + '?page=' + page + '&word=' + word + '&size=' + size + '&order=asc');
    }
  },
  create(form) {
    return api.request('POST', '/configuration/create', form);
  },
  delete(id) {
    return api.request('DELETE', '/configuration/delete/' + id);
  },
  getByID(id) {
    return api.request('GET', '/configuration/' + id);
  },
  update(id, form) {
    return api.request('PUT', '/configuration/update/' + id, form);
  },
  downloadFile(id) {
    return api.request('GET', '/configuration/generateConfigFile/' + id);
  }

}
